import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-bottom: -100px;
  height: 423px;
  background-image: url(${props => props.image});
  background-size: cover;

  @media (max-width: 576px) {
    height: 200px;
    margin-bottom: 0;
    background-attachment: initial;
  }
`;

const Cover = ({ image }) => (
  <Wrapper image={image} />
);

export default Cover;
